import React from "react";
import PrivateMiddleware from "./middleware/PrivateMiddleware";
//
import BaseTemplateIntranet from "../layout/BaseTemplateIntranet";

// views
import Dashboard from "../pages/Dashboard";
import Clients from "../pages/Clients/Clients.js";
import Employees from "../pages/Employees/Employees.js";
import Categories from "../pages/Categories/Categories";
import Products from "../pages/Products/Products";
import ServiceImages from "../pages/ServiceImages/ServiceImage";
import Services from "../pages/Services/Services";

import Orders from "../pages/Orders/Orders";
import Cancel_Orders from "../pages/Cancel_Orders/Cancel_Orders";
import Discounts from "../pages/Discounts/Discounts";
import Refunds from "../pages/Refunds/Refunds";

import RatingBadge from "../pages/RatingBadges/RatingBadges";

import Accounts from "../pages/Accounts/Accounts";
import DistancePrice from "../pages/DistancePrice/DistancePrice";

import ProfitsPercentage from "../pages/ProfitsPercentage/ProfitsPercentage";
import Search_Orders from "../pages/Search_orders/Search_Orders";

import Coments from "../pages/Comentarios/Comentarios.js";
{/*import Laundry from "../pages/Laundry/Laundry.js";*/}


const PRIVATE_ROUTES = {
    DASHBOARD: {
        path: "/intranet/dashboard",
        title: "Dashboard",
        component: Dashboard,
        exact: true,
        layout: props => <BaseTemplateIntranet {...props} />,
        middleware: props => <PrivateMiddleware {...props} />
    },
    CATEGORIES: {
        path: "/intranet/categories",
        title: "Servicios",
        component: Categories,
        exact: true,
        layout: props => <BaseTemplateIntranet {...props} />,
        middleware: props => <PrivateMiddleware {...props} />
    },
    CLIENTS: {
        path: "/intranet/clientes",
        title: "Clientes",
        component: Clients,
        exact: true,
        layout: props => <BaseTemplateIntranet {...props} />,
        middleware: props => <PrivateMiddleware {...props} />
    },
    EMPLOYEES: {
        path: "/intranet/empleados",
        title: "Empleados",
        component: Employees,
        exact: true,
        layout: props => <BaseTemplateIntranet {...props} />,
        middleware: props => <PrivateMiddleware {...props} />
    },
    ORDERS: {
        path: "/intranet/orders",
        title: "Ordenes",
        component: Orders,
        exact: true,
        layout: props => <BaseTemplateIntranet {...props} />,
        middleware: props => <PrivateMiddleware {...props} />
    },
    CANCEL:{
        path: "/intranet/cancel_orders",
        title: "Ordenes Canceladas",
        component: Cancel_Orders,
        exact: true,
        layout: props => <BaseTemplateIntranet {...props} />,
        middleware: props => <PrivateMiddleware {...props} />
    },
    SEARCH:{
        path: "/intranet/searching_orders",
        title: "Ordenes En Busqueda",
        component: Search_Orders,
        exact: true,
        layout: props => <BaseTemplateIntranet {...props} />,
        middleware: props => <PrivateMiddleware {...props} />
    },
    PRODUCTS: {
        path: "/intranet/productos",
        title: "Productos",
        component: Products,
        exact: true,
        layout: props => <BaseTemplateIntranet {...props} />,
        middleware: props => <PrivateMiddleware {...props} />
    },
    SERVICE_IMAGES: {
        path: "/intranet/imagenes-servicios",
        title: "Imagenes de servicios",
        component: ServiceImages,
        exact: true,
        layout: props => <BaseTemplateIntranet {...props} />,
        middleware: props => <PrivateMiddleware {...props} />
    },
    SERVICES: {
        path: "/intranet/servicios",
        title: "Servicios",
        component: Services,
        exact: true,
        layout: props => <BaseTemplateIntranet {...props} />,
        middleware: props => <PrivateMiddleware {...props} />
    },
    DISCOUNTS: {
        path: "/intranet/discounts",
        title: "Descuentos",
        component: Discounts,
        exact: true,
        layout: props => <BaseTemplateIntranet {...props} />,
        middleware: props => <PrivateMiddleware {...props} />
    },
    RATING_BADGES: {
        path: "/intranet/ratings",
        title: "Emblemas de calificacion",
        component: RatingBadge,
        exact: true,
        layout: props => <BaseTemplateIntranet {...props} />,
        middleware: props => <PrivateMiddleware {...props} />
    },
    REFUNDS: {
        path: "/intranet/refunds",
        title: "Administracion de devoluciones",
        component: Refunds,
        exact: true,
        layout: props => <BaseTemplateIntranet {...props} />,
        middleware: props => <PrivateMiddleware {...props} />
    },
    ACCOUNTS: {
        path: "/intranet/accounts",
        title: "Cuentas de administrador",
        component: Accounts,
        exact: true,
        layout: props => <BaseTemplateIntranet {...props} />,
        middleware: props => <PrivateMiddleware {...props} />
    },
    DISTANCE_PRICE: {
        path: "/intranet/distance",
        title: "Precio por distancia",
        component: DistancePrice,
        exact: true,
        layout: props => <BaseTemplateIntranet {...props} />,
        middleware: props => <PrivateMiddleware {...props} />
    },
    PROFITS_PERCENTAGE: {
        path: "/intranet/profits",
        title: "Porcentajes de ganancia",
        component: ProfitsPercentage,
        exact: true,
        layout: props => <BaseTemplateIntranet {...props} />,
        middleware: props => <PrivateMiddleware {...props} />
    },
    COMENTS: {
        path: "/intranet/coments",
        title: "Evaluaciones de Clientes",
        component: Coments,
        exact: true,
        layout: props => <BaseTemplateIntranet {...props} />,
        middleware: props => <PrivateMiddleware {...props} />
    },
    /*LAUNDRY: {
        path: "/intranet/laundry",
        title: "Lavanderia",
        component: Laundry,
        exact: true,
        layout: props => <BaseTemplateIntranet {...props} />,
        middleware: props => <PrivateMiddleware {...props} />
    },*/
}

export default PRIVATE_ROUTES;
